import { parseToken } from '@web/helpers/token';
import { basicLogger, ProviderConfig } from 'launchdarkly-react-client-sdk';

function buildLaunchDarklyConfig({ clientSideID, disabled }: { clientSideID: string; disabled: boolean }): ProviderConfig {
  const enabled = !disabled;
  const config: ProviderConfig = {
    clientSideID,
    options: {
      fetchGoals: enabled,
      streaming: enabled,
      sendEvents: enabled,
      logger: basicLogger({ level: 'none' }),
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  };
  return config;
}

function getUserIdFromToken(): string | undefined {
  const token = typeof window !== 'undefined' ? new URLSearchParams(window.location.hash.substring(1)).get('token') : null;
  if (token) {
    try {
      return parseToken(token).id;
    } catch {
      // Fall through to anonymous user
    }
  }
}

export function buildLaunchDarklyConfigWithUser(): ProviderConfig {
  const disabled = import.meta.env.VITE_APP_LAUNCH_DARKLY_DISABLED === 'true';
  const clientSideID = `${import.meta.env.VITE_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID}`;

  // Get `token` from URL fragment without React context
  const userId = getUserIdFromToken();

  const ldConfig = buildLaunchDarklyConfig({ clientSideID, disabled });
  ldConfig.context = {
    kind: 'user',
    key: userId ?? 'ANONYMOUS_USER',
    anonymous: !userId,
  };

  return ldConfig;
}
